import axios from 'axios';
import { BASE_URL } from '../../config';
import { getAccessToken } from '../LoginForm/Auth/auth';

export const getActiveSubstations = async ({ pripadnostVodu, month, year }) => {
    const token = getAccessToken();

    const response = await axios.get(`${BASE_URL}/api/active-substations`, {
        params: {
            pripadnostVodu,
            month,
            year,
        },
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });

    return response.data?.data || [];
};